import {FileUpload} from 'components/FileUpload';
import {connect} from 'react-redux';
import actionCreators from '../actionCreators/index';
import AnalyticsGateway from '../lib/AnalyticsGateway';

const mapStateToProps = (state) => {
  return {
    header: 'Add your own custom section',
    description: (
        <>
          <span>Drop a PDF or <strong><u>browse</u></strong> for it.</span> <br />
          <span>Max 10mb per file</span>
        </>
    ),
    propertyDetail: state.propertyDetail,
    accept: 'application/pdf',
    uploadProgress: state.uploadProgress,
    uploadText: 'Uploading pdf...',
    // below only used by mergeProps
    reportType: state.reportType.value,
    customErrorMessage: {
      'file-too-large': <span>Maximum file size is 10mb.</span>,
    },
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    // only used by mergeProps
    uploadPdf: (reportType, file) => {
      dispatch(actionCreators.uploadPdf(reportType, file));
    },
    logToSegment: (file, event, propertyId, reportType) => {
      const eventType = event.type === 'drop' ? 'Drop' : 'Browse';
      const reportDescription = AnalyticsGateway.reportDescription(reportType);
      AnalyticsGateway.sendEvent({
        eventName: 'Upload Custom PDF',
        properties: [
          {label: 'Page', value: 'Customise'},
          {label: 'Object Context', value: `Upload PDF ${eventType}`},
          {label: 'Property ID', value: propertyId},
          {label: 'Custom PDF Filename', value: file.name},
          {label: 'Report Type', value: reportDescription}
        ]
      });
    }
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    onUpload: (files, event, propertyId) => {
      dispatchProps.uploadPdf(stateProps.reportType, files[0]);
      dispatchProps.logToSegment(files[0], event, propertyId, stateProps.reportType);
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(FileUpload);